export default __webpack_public_path__ + "static/media/box-1Closed.3f92f24c.jpg";